<template>
    <div id="DpSetDestination">
        <div class="px-3">
            <p class="pa-2 headline">建物前までのお届けです</p>

            <h3>配送会社について</h3>
            <table>
                <tr>
                    <td>配達会社名</td>
                    <td>{{deliveryProvider.companyName}}</td>
                </tr>
                <tr v-for="(text,key) in deliveryFeeText" :key="key">
                    <td>{{text.title}}</td>
                    <td>{{text.desc}}</td>
                </tr>
            </table>
            <h3>戸口にはお伺いしません。</h3>
            <p>このサービスは、到着後、お客様に車両に商品を取りに来ていただくサービスです。</p>
            <h3>到着後、機械音声で電話しますので、車両に取りに来てください。</h3>

            <v-btn color="orange" block
                   to="/dpSetCustomerDetail"

            >
                了解して、お客様情報の登録へ
            </v-btn>

        </div>



    </div>
</template>
<script>
import  { Logger } from 'aws-amplify';
const logger = new Logger('DpSetDest','INFO');
import { AmplifyEventBus } from 'aws-amplify-vue'
export default {
    //
    // This page is navigated by beforeEnter at router.js
    //
    data() {
        return {
            deliveryFeeText:[
                {title:"最初の1.75kmまで",desc:"560円"},
                {title:"以降365mごと",desc:"70円"},
            ]
        }
    },
    created() {

    },
    beforeDestroy() {

    },
    async mounted() {
        logger.info("DpConsent")
        AmplifyEventBus.$emit('setBackTo', "/cart")
        logger.info("deliveryProvider",this.deliveryProvider)
    },
    methods:{

    },
    computed: {
        deliveryProvider: {
            get() {
                return this.$store.state.deliveryProvider
            },
            set(value) {
                this.$store.commit("setDeliveryProviderMT", value)
            }
        },
    },
}
</script>